import { Button, RadioGroup, SelectPicker } from 'rsuite';
import styled from 'styled-components';

export const StyledDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
`;

export const DropdownTitleWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

export const StyledDropdownTitle = styled.span`
  width: 100%;
  flex-grow: 1;
  :before {
    content: 'Selection: ';
    font-weight: 700;
  }
`;

export const AdvancedSelectionButton = styled(Button)`
  padding: 0px;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  margin: 5px 0;
`;

export const StyledSelectPicker = styled(SelectPicker)`
  width: 100%;
  margin-top: 10px;
`;
